/**
 * @generated SignedSource<<64315ee31e0375906ecd80c104eaca91>>
 * @relayHash d361e38bc3e6a4cdaee7ee2b23b19266
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e215e0a50c2e3225939330bb685856a3246a09ed84f86bde397207584a49ac89

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FirstCreateViewQuery } from './FirstCreateViewQuery.graphql';

const node: PreloadableConcreteRequest<FirstCreateViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e215e0a50c2e3225939330bb685856a3246a09ed84f86bde397207584a49ac89",
    "metadata": {},
    "name": "FirstCreateViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
